// Public Supabase endpoint config.
//
// These are PUBLIC values: the project URL and the `anon` publishable key are
// designed to be exposed in client-side code (Row Level Security protects the
// data, not key secrecy). We read from NEXT_PUBLIC_* env vars when present, but
// fall back to the hardcoded project values so the contact forms keep working
// even when a host builds the site without the env vars configured.
//
// Without these fallbacks, an undefined URL produces `fetch("undefined/...")`,
// which throws "The string did not match the expected pattern" in Safari.

export const SUPABASE_URL =
  process.env.NEXT_PUBLIC_SUPABASE_URL || 'https://baxwbiwdwyhamsmlrffg.supabase.co';

export const SUPABASE_ANON_KEY =
  process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJheHdiaXdkd3loYW1zbWxyZmZnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzk5NDI0MjcsImV4cCI6MjA5NTUxODQyN30.ZueysbPhfwWGUyERxhspw4fPjfBJWTxIIKhxe_NCMjw';

export const CONTACT_EMAIL_ENDPOINT = `${SUPABASE_URL}/functions/v1/send-contact-email`;
